// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { CHATFLOW_BY_UNIQUE_ID } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceIdType from 'reference-resolvers/schema/ReferenceIdType';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
import UILink from 'UIComponents/link/UILink';
import { chatflowUrl } from 'automation-ui-references/routing/hubspotUrls';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Example:
 *   <ChatflowName id="123" />
 * Renders as:
 *   Random chatflow name
 */
const ChatflowName = ({
  id
}) => {
  return /*#__PURE__*/_jsx(ReferenceName, {
    id: id,
    referenceObjectType: CHATFLOW_BY_UNIQUE_ID,
    onResolved: ({
      reference
    }) => {
      const chatflowId = reference.get('id');
      const chatflowName = reference.get('label');
      const chatflowReferencedObject = reference.get('referencedObject');
      const chatflowSource = chatflowReferencedObject.get('chatflowSource');
      const chatflowDeleted = !!chatflowReferencedObject.get('deletedAt'); // this is 0 if not deleted

      const showChatflowLink = !chatflowDeleted && chatflowId && chatflowSource;
      return showChatflowLink ? /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: chatflowUrl(chatflowId, chatflowSource),
        children: chatflowName
      }) : chatflowName;
    }
  });
};
ChatflowName.propTypes = {
  id: ReferenceIdType.isRequired
};
export default ChatflowName;